import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import axios from "../../../axios";
import Alert from "react-s-alert";
import CustomModal from "../../../components/CustomModal";
import FormDropdown from '../../../components/FormDropdown';
import AddModal from "../../../components/AddModal";
import qs from "qs";
import Paging from "../../../components/Paging";
import { FOTO_CONTENT_HOST } from "../../../constants/siteConfig";
import Select from "react-select";
import {Col, Row} from "reactstrap";
import ImageZoom from "react-medium-image-zoom";

const tipe_soal = [
    { value: "", label: "Pilih Tipe" },
    { value: "single", label: "Single Option" },
    { value: "essay", label: "Essay" }
];

class Soal extends React.Component {
    constructor() {
        super();
        this.state = {
            dataSoal: [],
            detailSoal: [],
            dataMapel:[],
            dataGuru:[],
            dataUser:[],
            exam_cat_id: 0,
            mapel_id:"",
            pageCount: 0,
            currentPage: 0,
            isLoading: false,
            isDetailExamLoading: false,
            isModalShow: false,
            question_id:"",
            user_id : "",
            upload_by : "",
            question_type : "",
            cari : "",
            totQue : 0,
            totAdd : 0,
            startNo: 1
        };
        this.toggleModal = this.toggleModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeMultiSelect = this.handleChangeMultiSelect.bind(this);


    }

    handleChangeMultiSelect(stateName, text) {
        this.setState({[stateName]: text});

    }

    handlePageClick(data) {
        let selected = data.selected; // zero based index

        this.setState({ currentPage: selected }, () => {
            this.loadData();
        });
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name] : value,
        })

    }

    loadDataDetail(e) {

        this.setState({ isLoading: true });
        axios({
            method: "post",
            url: '/soal/edit',
            data: qs.stringify({ question_id: e})
        })

            .then(response => {
                const result = response.data;
                if (result.success === true) {
                    this.setState({
                        detailSoal: result.data,
                        question_id: result.data.question_id,
                        isLoading: false
                    });

                } else {
                    Alert.error(result.message);
                    this.setState({ isLoading: false });
                }

            })

            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadData() {
        this.setState({ isLoading: true });
        axios({
            method: "post",
            url: '/ujian/soal',
            data: qs.stringify({ id: localStorage.SISMART_USER_ID,
                mapel : this.props.match.params.mapel_id,
                exam: this.props.match.params.exam_id,
                upload : this.state.upload_by,
                question_type:this.state.question_type,
                cari: this.state.cari,
                page: this.state.currentPage + 1 })
        })
            .then(response => {
                const result = response.data;
                if (result.success === true) {
                    this.setState({
                        dataSoal: result.data.data,
                        totQue: result.data.total,
                        totAdd: result.totAdd,
                        pageCount: result.data.last_page,
                        startNo: result.data.from,
                        isLoading: false
                    });
                } else {
                    Alert.error(result.message);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    toggleModal(e) {
        this.setState({
            modalShow: !this.state.modalShow,
            question_id : e,
        });

        if (!this.state.modalShow) {
            this.loadDataDetail(e);
        }else{
            this.loadData();
        }
    }

    loadDataUser() {


        axios.post("/userupsoal")
            .then(response => {

                return response.data.data.map(item => ({
                    value   : item.user_id,
                    label : item.user_nama
                }))
            })
            .then(result => {
                result = result.slice(0);
                result.splice(this.state.result, 0, {value:'', label:'Diupload Oleh'});

                this.setState({
                    dataUser: result
                })
            })
            .catch(error => {
                console.log(error)
            })
    }


    componentDidMount() {
        this.loadData();
        this.loadDataMapel();
        this.loadDataGuru();
        this.loadDataUser();

    }

    loadDataMapel(){
        axios.post("/mapel?sortby=1")
            .then(response => {
                return response.data.data.map(item => ({
                    value	: item.mapel_id,
                    label	: item.mapel_nama
                }))
            })
            .then(result => {
                result = result.slice(0);
                result.splice(this.state.result, 0, {value:'',label:'Pilih Mapel'});

                this.setState({
                    dataMapel: result
                })
            })
            .catch(error => {
                console.log("Mapel Undefinded")
            })
    }


    loadDataGuru() {

        const params = qs.stringify({
            level: "guru"
        })

        axios.post("/user?" + params)
            .then(response => {

                return response.data.data.map(item => ({
                    value   : item.user_id,
                    label : item.user_nama
                }))
            })
            .then(result => {
                result = result.slice(0);
                result.splice(this.state.result, 0, {value:'',label:'Pilih Guru'});

                this.setState({
                    dataGuru: result
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevState.mapel_id !== this.state.mapel_id || prevState.upload_by !== this.state.upload_by ||
            prevState.question_type !== this.state.question_type || prevState.cari !== this.state.cari ) {
            this.loadData()
        }

    }

    render() {
        return (
            <div className="col-sm-12">
                <AddModal
                    modalHeaderText="Add Soal"
                    modalBodyText = ""
                    modalSubmitText="Add Soal"
                    detailSoal = {this.state.detailSoal}
                    detailExam = {this.props.match.params.exam_id}
                    toggleModal={this.toggleModal}
                    isShow={this.state.modalShow}
                />
                <div className="card">
                    <div className="card-header">
                        Pilih Soal
                    </div>
                    <div className="card-block">
                        <div className="form-group row">
                            <div className="col-md-3">
                                <Select
                                    name="upload_by"
                                    simpleValue
                                    value={this.state.upload_by.toString()}
                                    clearable={false}
                                    placeholder={"Diupload Oleh"}
                                    onChange={text =>
                                        this.handleChangeMultiSelect("upload_by", text)
                                    }
                                    options={this.state.dataUser}
                                    isLoading={this.state.isLoading}
                                />
                            </div>
                            <div className="col-md-3">
                                <Select
                                    name="mapel_id"
                                    simpleValue
                                    value={this.state.mapel_id.toString()}
                                    clearable={false}
                                    placeholder={"Pilih Mapel"}
                                    onChange={text =>
                                        this.handleChangeMultiSelect("mapel_id", text)
                                    }
                                    options={this.state.dataMapel}
                                    isLoading={this.state.isLoading}
                                />
                            </div>
                            <div className="col-md-3">
                                <Select
                                    name="question_type"
                                    simpleValue
                                    value={this.state.question_type.toString()}
                                    clearable={false}
                                    placeholder={"Pilih Type"}
                                    onChange={text =>
                                        this.handleChangeMultiSelect("question_type", text)
                                    }
                                    options={tipe_soal}
                                    isLoading={this.state.isLoading}
                                />
                            </div>
                            <div className="col-md-6" style={{ marginTop:'10px' }}>
                                <input
                                    name="cari"
                                    type="text"
                                    className="form-control"
                                    placeholder="Ketikkan Soal ..."
                                    value={this.state.cari}
                                    onChange={this.handleChange}
                                />
                            </div>
                        </div>
                        <Row>
                            <Col xs="12" lg="2">
                                <div className="card">
                                    <div className="card-header">
                                        Total Soal
                                    </div>
                                    <div className="card-block">
                                        {
                                            this.state.isLoading ? "Memuat Data..." : (
                                                <div>
                                                    <div className="alert alert-warning" role="alert" style={{ textAlign:'center' }}>
                                                        <h4>{this.state.totQue}</h4>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </Col>
                            <Col xs="12" lg="2">
                                <div className="card">
                                    <div className="card-header">
                                        Total Soal Ditambah
                                    </div>
                                    <div className="card-block">
                                        {
                                            this.state.isLoading ? "Memuat Data..." : (
                                                <div>
                                                    <div className="alert alert-warning" role="alert" style={{ textAlign:'center' }}>
                                                        <h4>{this.state.totAdd}</h4>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        {this.state.isLoading ? (
                            "Memuat Data..."
                        ) : this.state.dataSoal.length === 0 ? (
                            "Data Kosong..."
                        ) : (
                            <div>
                                <table className="table table-striped table-bordered animated fadeIn">
                                    <thead>
                                    <tr>
                                        <th width={20}>No.</th>
                                        <th>Mapel</th>
                                        <th>Pertanyaan</th>
                                        <th width={50}>Tags</th>
                                        <th>Type</th>
                                        <th>Upload By</th>
                                        <th width="150">Opsi</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.dataSoal.map((item,i) => {
                                        return (
                                            <tr key={item.question_id}>
                                                <td>{i+this.state.startNo}</td>
                                                <td>{item.mapel.mapel_nama}</td>
                                                {item.question_pict !==null?(
                                                    <td>
                                                        <div dangerouslySetInnerHTML={{ __html: item.question_text }} />
                                                        {
                                                            item.question_pict ?(
                                                                <div>
                                                                    <ImageZoom
                                                                        image={{
                                                                            src:"data:"+ item.question_type_pict + ";base64,"+item.question_pict,
                                                                            className: 'img',
                                                                            style: { width: '10em' }
                                                                        }}
                                                                    />
                                                                </div>
                                                            ):""
                                                        }
                                                    </td>
                                                ):(
                                                    <td><div dangerouslySetInnerHTML={{ __html: item.question_text }} /></td>

                                                )}

                                                <td>
                                                    {
                                                        Array.isArray(item.keterangan) ? (
                                                        item.keterangan.length > 0 ?
                                                            item.keterangan.map((ite, a)=>{
                                                                return(<div><span className="badge badge-danger">{ ite }</span>{" "}</div>)
                                                            })
                                                            :(
                                                                <span className="badge badge-danger">No Tags</span>
                                                            )
                                                            ):(
                                                            <span className="badge badge-danger">No Tags</span>
                                                        )

                                                    }
                                                </td>
                                                <td>{item.question_type}</td>
                                                <td>{item.user_nama}</td>

                                                <td>
                                                    {
                                                        item.isAdd ? (
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btn-sm">
                                                                Sudah ditambah
                                                            </button>
                                                        ):(
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() => {
                                                                    this.toggleModal(item.question_id);
                                                                    this.setState({ question_id: item.question_id });
                                                                }} >
                                                                Tambah
                                                            </button>
                                                        )
                                                    }

                                                </td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>

                                <Paging
                                    handlePageClick={this.handlePageClick.bind(this)}
                                    pageCount={this.state.pageCount}
                                    currentPage={this.state.currentPage}
                                />
                            </div>
                        )}
                    </div>

                </div>
            </div>
        );
    }
}

export default Soal;



// WEBPACK FOOTER //
// ./src/views/Exam/Schedule/AddSoal.js